export default {
    RECHERCHELISTS ({ rechercheLists }) {
      return rechercheLists
    },
    ADDRESSLISTS ({ addresslist }) {
      return addresslist
    },
    AMBASSADORSLIST ({ ambassadorslist }) {
      return ambassadorslist
    },
    MEILISEARCHCONTENT ({ meilisearchContent }) {
      return meilisearchContent
    },
    SEARCHPARAM_MS ({ searchParamMeiliSearch }) {
      return searchParamMeiliSearch
    },
    TOTALCOUNT_MS ({ totalCountMeiliSearch }) {
      return totalCountMeiliSearch
    },
    COMPLETE_CUSTOM_FILTER ({ completeCustomFilter }) {
      return completeCustomFilter
    },
    SAVE_LIST_MAX_LIMIT ({ saveListMaxLimit }) {
      return saveListMaxLimit
    },
    LAST_ADDED_POOLDATA ({ lastAddedList }) {
      return lastAddedList
    },
    POOL_DATA ({ poolData }) {
      return poolData
    },
    ADDED_LIST_STATUS ({ lastListAddedStatus }) {
      return lastListAddedStatus
    },
    SAVE_QUERY_ALL_FILTERS ({ saveQueryAllFilters }) {
      return saveQueryAllFilters
    },
    SAVEDLISTS_NAMES ({ savedListsNames }) {
      return savedListsNames
    },
    SAVEDLISTS ({ savedLists }) {
      return savedLists
    },
    IMPORTEDSAVEDLISTS ({ importedSavedLists }) {
      return importedSavedLists
    }
  }
